import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface LegalPageProps {
  title: string
  lastUpdated: string
  children: React.ReactNode
}

export function LegalPage({ title, lastUpdated, children }: LegalPageProps) {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-8">
          <ArrowLeft size={16} /> Back
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-indigo-500 rounded-lg flex items-center justify-center">
            <span className="text-white text-lg font-bold">S</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
        </div>

        <p className="text-sm text-gray-400 mb-10">Last updated: {lastUpdated}</p>

        <div className="prose prose-gray max-w-none [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-gray-900 [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-medium [&_h3]:text-gray-800 [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:text-gray-600 [&_p]:leading-relaxed [&_p]:mb-4 [&_ul]:space-y-1 [&_ul]:text-gray-600 [&_li]:leading-relaxed [&_strong]:text-gray-900">
          {children}
        </div>

        <div className="flex flex-wrap gap-4 text-sm text-gray-500 pt-8 mt-12 border-t border-gray-200">
          <a href="/security" className="hover:text-indigo-600">Security</a>
          <a href="/terms" className="hover:text-indigo-600">Terms of Service</a>
          <a href="/privacy" className="hover:text-indigo-600">Privacy Policy</a>
          <a href="/baa" className="hover:text-indigo-600">BAA</a>
        </div>

        <footer className="mt-8 text-center text-sm text-gray-400">
          © {new Date().getFullYear()} TailwindX, LLC. All rights reserved.
        </footer>
      </div>
    </div>
  )
}
